import React from "react";
import createReactClass from "create-react-class";

import ModalPhotoViewerFooter from "./modal_photo_viewer_footer";

var ModalPhotoViewer = createReactClass({
  nextPhoto() {
    this.props.onChange(this.props.photoIndex + 1);
  },
  previousPhoto() {
    this.props.onChange(this.props.photoIndex - 1);
  },
  render() {
    if (!this.props.isOpen) {
      return null;
    }
    return (
      <div
        className="modal-photo-viewer"
        style={ModalPhotoViewer.styles.overAll}
      >
        <div
          onClick={this.props.onClose}
          style={ModalPhotoViewer.styles.overlay}
        />
        <div className="container" style={ModalPhotoViewer.styles.content}>
          <div style={ModalPhotoViewer.styles.header}>
            <div
              onClick={this.props.onClose}
              style={{
                fontSize: "35px",
                float: "left",
                marginTop: "-12px",
                fontWeight: "200",
              }}
            >
              ×
            </div>
            <i
              className="fas fa-cog"
              aria-hidden="true"
              onClick={this.props.onClose}
              style={{ paddingTop: "5px", float: "right", display: "none" }}
            />
          </div>
          <img
            id={this.props.photoDir}
            className="img-responsive"
            src={this.props.photoUrl}
          />
          <div
            onClick={this.previousPhoto}
            style={ModalPhotoViewer.styles.leftButton}
          >
            <i className="fas fa-angle-left" />
          </div>
          <div
            onClick={this.nextPhoto}
            style={ModalPhotoViewer.styles.rightButton}
          >
            <i className="fas fa-angle-right" />
          </div>
          <ModalPhotoViewerFooter isActive={false} />
        </div>
      </div>
    );
  },
});

ModalPhotoViewer.styles = {
  overAll: {
    position: "fixed",
    bottom: "0",
    height: "100%",
    width: "100%",
    top: "0",
    left: "0",
    right: "0",
    zIndex: "1000",
    textShadow: "0px 0px 6px #949494",
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.9)",
    position: "fixed",
    height: "100%",
    width: "100%",
    zIndex: "1001",
  },
  content: {
    position: "relative",
    margin: "auto",
    height: "100%",
    width: "100%",
    zIndex: "1010",
  },
  header: {
    position: "absolute",
    left: "0%",
    top: "0%",
    height: "40px",
    width: "100%",
    padding: "0px 10px",
    color: "#fff",
    fontSize: "25px",
    zIndex: "1020",
  },
  rightButton: {
    position: "absolute",
    right: "0%",
    top: "45%",
    display: "block",
    height: "auto",
    marginLeft: "10px",
    marginRight: "10px",
    zIndex: "1015",
    color: "#fff",
    fontSize: "40px",
  },
  leftButton: {
    position: "absolute",
    left: "0%",
    top: "45%",
    display: "block",
    height: "auto",
    marginLeft: "10px",
    marginRight: "10px",
    zIndex: "1015",
    color: "#fff",
    fontSize: "40px",
  },
  photoW: {
    position: "absolute",
    left: "50%",
    top: "50%",
    WebkitTransform: "translate3d(-50%, -50%, 0)",
    Transform: "translate3d(-50%, -50%, 0)",
    display: "block",
    width: "100%",
    height: "auto",
    marginLeft: "auto",
    marginRight: "auto",
  },
  photoH: {
    position: "absolute",
    left: "50%",
    top: "50%",
    WebkitTransform: "translate3d(-50%, -50%, 0)",
    Transform: "translate3d(-50%, -50%, 0)",
    display: "block",
    maxWidth: "200%",
    height: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  footerItemBox: {
    display: "table-cell",
    height: "100%",
    verticalAlign: "middle",
    marginTop: "auto",
    marginBottom: "auto",
    textAlign: "center",
    color: "#fff",
  },
  footerIcon: {
    height: "40px",
    lineHeight: "40px",
    fontSize: "20px",
  },
  footerText: {
    height: "40px",
    lineHeight: "40px",
    fontSize: "15px",
    fontWeight: "bold",
  },
};

export default ModalPhotoViewer;
